import { render, staticRenderFns } from "./DuoJiSalesChangeTransfer.vue?vue&type=template&id=1cec8516&scoped=true"
import script from "./DuoJiSalesChangeTransfer.vue?vue&type=script&lang=js"
export * from "./DuoJiSalesChangeTransfer.vue?vue&type=script&lang=js"
import style0 from "./DuoJiSalesChangeTransfer.vue?vue&type=style&index=0&id=1cec8516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec8516",
  null
  
)

export default component.exports